export const environment = {
  production: false,
  development: true,
  localhost: false,
  apiIsProxy: false,
  envName: 'qa',
  omniChannelAPI: '/api',
  appFlavor: 'OmniChannel',
  appName: 'Extend My Park',
  applicationVersion: '100',
  applicationPlatform: 'web',
  retyCount: 1,

  reCaptchaKey: '6Le7WuIUAAAAADZQVEoyc9xG1oFeL7mUQeqKToML',

  amexEnabled: true,
  fatZebraTestMode: true,

  googlePayEnvironment: "TEST",
  googlePayGatewayName: "fatzebra",
  googlePayGatewayMerchantId: "TESTOrikan-aec81d4df2b7e5d9",
  googlePayMerchantName: "Example",
  googlePayMerchantId: "TODO",

  firebaseConfig: {
    apiKey: "AIzaSyC8zD2RDuwpkTzHiBdz2lGIEMVZWk7-nY8",
    authDomain: "paystay-dev-qa-uat-preprod.firebaseapp.com",
    databaseURL: "https://paystay-dev-qa-uat-preprod.firebaseio.com",
    projectId: "paystay-dev-qa-uat-preprod",
    storageBucket: "paystay-dev-qa-uat-preprod.appspot.com",
    messagingSenderId: "432773183642",
    appId: "1:432773183642:web:e0be1f05239c7390",
    measurementId: "G-T1F2QDV9F1"
  }
};
